import { useMutation, useQueryClient } from "@tanstack/react-query"
import { updatePaymentStatus } from "@/lib/api/order.api"
import { useAuthStore } from "@/store/auth.store"

export function useUpdatePaymentStatus(orderId: string) {
  const accessToken = useAuthStore((s) => s.accessToken)
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({ paymentId, status }: { paymentId: string; status: "PENDING" | "COMPLETED" | "FAILED" }) => {
      if (!accessToken) throw new Error("Not authenticated")
      return updatePaymentStatus(orderId, paymentId, status, accessToken)
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["order-payments", orderId] })
      queryClient.invalidateQueries({ queryKey: ["buyer-order-detail", orderId] })
    },
  })
}
